import {
  RFAConfigDTO,
  FloorConfigDTO,
  RiserDTO,
  FloorDTO,
  ApartmentDTO,
  BuildingDTO,
  AddressBookSorting,
} from '@/../client-generator/generated-clients/plants';

interface RiserFloorsApartments {
  riser: RiserDTO;
  floors: { floor: FloorDTO; apartments: ApartmentDTO[] }[];
}

enum CallMode {
  Address = 0,
  Brfa = 1,
  DirectCall = 2,
}

enum EPDeviceTypeEnum
{
    linea5000 = 0,
    KeyPad = 1,
    SmartAccess = 2
}

const addressBookSortingOptions = Object.keys(AddressBookSorting).reduce(
  (t: any, k: any) => {
    if (!isNaN(+k)) {
      t.push({
        name: AddressBookSorting[k],
        code: +k,
      });
    }
    return t;
  },
  []
);

const noAppartmentOptions = Array.from({ length: 3999 }, (_, index) => ({
  label: (index + 1).toString(),
  value: index + 1,
}));

const distributeApartmentsToRaisersAndFloors = (structure: RFAConfigDTO) => {
  if (!structure.risers) return;
  if (structure.risers.length > 0) {
    var distribution = distributeElementsInGroups(
      structure.numberOfApartments!,
      structure.risers.length
    );
    for (let riser of structure.risers) {
      const riserIndex = structure.risers.indexOf(riser);
      const numberOfApartmentsInRiser = distribution[riserIndex];
      distributeApartmentsToFloors(riser.floors!, numberOfApartmentsInRiser);
    }
  } else {
    distributeApartmentsToFloors(
      structure.floorsWithoutRiser!,
      structure.numberOfApartments!
    );
  }
};

function distributeApartmentsToFloors(
  floors: FloorConfigDTO[],
  numberOfApartments: number
) {
  var distribution = distributeElementsInGroups(
    numberOfApartments,
    floors.length
  );
  for (let floor of floors) {
    var floorIndex = floors.indexOf(floor);
    floor.numberOfApartments = distribution[floorIndex];
  }
}

function distributeElementsInGroups(
  numberOfElements: number,
  numberOfGroups: number
): number[] {
  if (numberOfGroups < 1) throw new Error('Out of range');

  if (numberOfElements < 1)
    return Array.from({ length: numberOfGroups }, () => 0);

  const numberOfElementsInGroup = (numberOfElements / numberOfGroups) >> 0;
  const groupsWithExtraElement = numberOfElements % numberOfGroups;

  const distribution: number[] = [];
  for (let groupIndex = 0; groupIndex < numberOfGroups; groupIndex++) {
    const elementsInGroup =
      groupIndex < groupsWithExtraElement
        ? numberOfElementsInGroup + 1
        : numberOfElementsInGroup;
    distribution.push(elementsInGroup);
  }
  return distribution;
}

function getDeviceIconFromType(t: number | undefined): string {
  switch (t) {
    case 0:
      return 'entrancePlants/icon-new-pe';
    case 1:
      return 'entrancePlants/icon-keypad';
    case 2:
      return 'entrancePlants/icon-smart-reader';
    default:
      return '';
  }
}

function isCodeCorrectValue(code: string, codeRequiredLength: number = 5) {
  const regex = new RegExp(`[0-9]{${codeRequiredLength}}`);
  if (!code) return false;
  return code.length === codeRequiredLength && regex.test(code);
}

function loadRisersFloorsApartments(building: BuildingDTO) {
  const risers: RiserFloorsApartments[] = [];
  if (building?.risers === undefined) return risers;

  for (const riser of building.risers) {
    const floors = building.floors!.filter(
      (floor) => floor.riserId === riser.riserId
    );
    const floorsApartments: {
      floor: FloorDTO;
      apartments: ApartmentDTO[];
    }[] = [];
    for (const floor of floors) {
      const apartments = building.apartments!.filter(
        (apartment) => apartment.floorId === floor.floorId
      );
      floorsApartments.push({ floor: floor, apartments: apartments });
    }

    risers.push({
      riser: riser,
      floors: floorsApartments,
    });
  }
  return risers;
}

export {
  distributeApartmentsToRaisersAndFloors,
  loadRisersFloorsApartments,
  addressBookSortingOptions,
  getDeviceIconFromType,
  noAppartmentOptions,
  isCodeCorrectValue,
  EPDeviceTypeEnum,
  CallMode,
};